"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var date_fns_1 = require("date-fns");
var ArrowUpIcon_1 = require("../../Icons/ArrowUpIcon");
var ArrowDownIcon_1 = require("../../Icons/ArrowDownIcon");
function generateYears(year, noOfYear) {
    var list = [];
    for (var i = 0; i < 2 * noOfYear + 1; i++) {
        list.push(year + noOfYear - i);
    }
    return list;
}
var YearDropdownOptions = /** @class */ (function (_super) {
    __extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollInterval = null;
        _this.filteredYearsList = function () {
            return _this.state.yearsList.filter(function (value) {
                if (_this.props.minDate && value < date_fns_1.getYear(_this.props.minDate)) {
                    return false;
                }
                else if (_this.props.maxDate && value > date_fns_1.getYear(_this.props.maxDate)) {
                    return false;
                }
                else if (_this.props.includeDates &&
                    _this.props.includeDates.map(function (date) { return date_fns_1.getYear(date); }).filter(function (year) { return year === value; }).length === 0) {
                    return false;
                }
                return true;
            });
        };
        _this.renderOptions = function () {
            var selectedYear = _this.props.year;
            var filteredYears = _this.filteredYearsList();
            var options = filteredYears.map(function (year) { return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            React.createElement("div", { className: classNames('ee_react-datepicker__year-option', {
                    'ee_react-datepicker__year-option--selected': selectedYear === year
                }), key: year, onClick: _this.onChange.bind(_this, year) }, year)); });
            // button to next years
            options.unshift(React.createElement("button", { className: "ee_react-datepicker__year-option", key: 'upcoming', onClick: _this.incrementYears, onMouseDown: function () {
                    _this.startScrollInterval(1);
                }, onMouseUp: _this.stopScrollInterval, onMouseLeave: _this.stopScrollInterval, disabled: !_this.isNextAllowed(filteredYears) },
                React.createElement(ArrowUpIcon_1.default, { width: 20, height: 20, title: "sp\u00E4ter" })));
            // button to previous years
            options.push(React.createElement("button", { className: "ee_react-datepicker__year-option", key: 'previous', onClick: _this.decrementYears, onMouseDown: function () {
                    _this.startScrollInterval(-1);
                }, onMouseUp: _this.stopScrollInterval, onMouseLeave: _this.stopScrollInterval, disabled: !_this.isPreviousAllowed(filteredYears) },
                React.createElement(ArrowDownIcon_1.default, { width: 20, height: 20, title: "fr\u00FCher" })));
            return options;
        };
        _this.isNextAllowed = function (years) {
            var maxYear = Math.max.apply(Math, years);
            var upcomingDisabled = false;
            if (_this.props.maxDate && maxYear >= date_fns_1.getYear(_this.props.maxDate)) {
                upcomingDisabled = true;
            }
            if (!upcomingDisabled && _this.props.includeDates && maxYear >= Math.max.apply(Math, _this.props.includeDates.map(date_fns_1.getYear))) {
                upcomingDisabled = true;
            }
            return !upcomingDisabled;
        };
        _this.isPreviousAllowed = function (years) {
            var minYear = Math.min.apply(Math, years);
            var previousDisabled = false;
            if (_this.props.minDate && minYear <= date_fns_1.getYear(_this.props.minDate)) {
                previousDisabled = true;
            }
            if (!previousDisabled && _this.props.includeDates && minYear <= Math.min.apply(Math, _this.props.includeDates.map(date_fns_1.getYear))) {
                previousDisabled = true;
            }
            return !previousDisabled;
        };
        _this.onChange = function (year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function () {
            _this.props.onCancel();
        };
        _this.shiftYears = function (amount) {
            if ((amount > 0 && _this.isNextAllowed(_this.state.yearsList)) ||
                (amount < 0 && _this.isPreviousAllowed(_this.state.yearsList))) {
                var years = _this.state.yearsList.map(function (year) {
                    return year + amount;
                });
                _this.setState({
                    yearsList: years
                });
            }
        };
        _this.incrementYears = function () {
            _this.shiftYears(1);
        };
        _this.decrementYears = function () {
            _this.shiftYears(-1);
        };
        _this.stopScrollInterval = function () {
            if (_this.scrollInterval) {
                clearInterval(_this.scrollInterval);
                _this.scrollInterval = null;
            }
        };
        _this.startScrollInterval = function (increment) {
            if (increment === void 0) { increment = 1; }
            _this.stopScrollInterval();
            _this.scrollInterval = setInterval(function () {
                _this.shiftYears(increment);
            }, 150);
        };
        _this.state = {
            yearsList: props.scrollableYearDropdown ? generateYears(props.year, 10) : generateYears(props.year, 2)
        };
        return _this;
    }
    /**
     * Stop Interval Timer if for some reason the component is unmounted
     * while timer is running
     */
    YearDropdownOptions.prototype.componentWillUnmount = function () {
        this.stopScrollInterval();
    };
    YearDropdownOptions.prototype.render = function () {
        var dropdownClass = classNames({
            'ee_react-datepicker__year-dropdown': true,
            'ee_react-datepicker__year-dropdown--scrollable': this.props.scrollableYearDropdown
        });
        return React.createElement("div", { className: dropdownClass }, this.renderOptions());
    };
    YearDropdownOptions.propTypes = {
        onCancel: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        maxDate: PropTypes.instanceOf(Date),
        minDate: PropTypes.instanceOf(Date),
        scrollableYearDropdown: PropTypes.bool,
        year: PropTypes.number.isRequired,
        includeDates: PropTypes.array
    };
    return YearDropdownOptions;
}(React.Component));
exports.YearDropdownOptions = YearDropdownOptions;
exports.default = YearDropdownOptions;
//# sourceMappingURL=year_dropdown_options.js.map